export default "__VITE_ASSET__DrYjv78D__"